module.exports = __webpack_public_path__ + "static/media/intro.0384a825.mp3";